import _ from 'lodash';
import { useHistory } from 'react-router-dom';

export function useQueryParameters<K extends string>(keys: K[]): Record<K, string | null> {
	const history = useHistory();

	const params = new URLSearchParams(history.location.search);

	return _.fromPairs(keys.map((key) => [key, params.get(key)])) as Record<K, string | null>;
}
